import React from "react";

import useI18nNamespace from "@services/useI18nNamespace";

import { TrustBarContainer, StyledFlexBox, StyledImage, TrustBarHeader } from "./Footer.styles";

export const Footer = () => {
  const { t } = useI18nNamespace("free-trial-registration");

  const images = [
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/plg-assets/pizza-hut.svg",
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Chime.svg",
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/elf.svg",
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Going.svg",
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Guardian.svg",
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/MAX.svg",
    "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Styli.svg",
  ];
  return (
    <StyledFlexBox>
      <TrustBarHeader level={2}>{t("footer-title", "Trusted by brands everywhere")}</TrustBarHeader>
      <TrustBarContainer>
        {images.map((image, index) => (
          <StyledImage key={index} src={image} />
        ))}
      </TrustBarContainer>
    </StyledFlexBox>
  );
};
